module.exports = [
  ...require('./b'),
  ...require('./c'),
  ...require('./f'),
]
